import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { screenOptions } from './NavigationUtils';
import { LoginScreen, RegisterScreen } from '../screens/auth';
import { 
  MenuScreen, 
  MenuCategoryScreen, 
  MenuItemScreen 
} from '../screens/user';

const Stack = createStackNavigator();

const AuthNavigator = () => {
  return (
    <Stack.Navigator
      initialRouteName="Login"
      screenOptions={screenOptions}
    >
      <Stack.Screen 
        name="Login" 
        component={LoginScreen} 
        options={{ title: 'Giriş Yap' }}
      />
      <Stack.Screen 
        name="Register" 
        component={RegisterScreen} 
        options={{ title: 'Üye Ol' }}
      />
      <Stack.Screen 
        name="MenuMain" 
        component={MenuScreen} 
        options={{ 
          title: 'Menü', 
          headerStyle: {
            backgroundColor: 'rgb(125, 76, 236)',
          },
          headerTintColor: '#fff',
          headerTitleStyle: {
            fontWeight: 'bold',
          }
        }}
      />
      <Stack.Screen 
        name="MenuCategory" 
        component={MenuCategoryScreen} 
        options={({ route }) => ({ 
          title: route.params?.categoryName || 'Kategori',
          headerStyle: {
            backgroundColor: 'rgb(125, 76, 236)',
          },
          headerTintColor: '#fff',
          headerTitleStyle: {
            fontWeight: 'bold',
          }
        })}
      />
      <Stack.Screen 
        name="MenuItem" 
        component={MenuItemScreen} 
        options={({ route }) => ({ 
          title: route.params?.itemName || 'Ürün Detayı',
          headerStyle: {
            backgroundColor: 'rgb(125, 76, 236)',
          },
          headerTintColor: '#fff',
          headerTitleStyle: {
            fontWeight: 'bold',
          }
        })}
      />
    </Stack.Navigator>
  );
};

export default AuthNavigator;
